import { AnySourceStream, AnySubscription, Stream, Subscription } from '../stream'

export class LastOn<V = any, E = any, C = any> extends Stream<V, E, C> {
    protected flushSubscription: AnySubscription = {
        value: () => {
            this.flush()
        },
        error: () => {
            this.flush()
            this.close()
        },
        complete: () => {
            this.flush()
            this.close()
        },
    }

    protected last: V | undefined
    protected receive = false

    private shouldComplete = false
    private completeValue: C | undefined = undefined
    private subscription: Subscription<V, E, C> = {
        value: this.value.bind(this),
        error: this.error.bind(this),
        complete: (completeValue) => {
            this.shouldComplete = true
            this.completeValue = completeValue
        },
    }

    constructor(protected signal: Stream, protected source?: AnySourceStream<V, E, C>) {
        super()
        this.signal = signal
    }

    connect() {
        super.connect()
        if (this.source) this.source.subscribe(this.subscription)

        this.signal.subscribe(this.flushSubscription)
    }

    disconnect() {
        super.disconnect()

        if (this.source) this.source.unsubscribe(this.subscription)

        this.signal.unsubscribe(this.flushSubscription)
    }

    flush() {
        if (this.receive) this._value(this.last!)
        this.receive = false

        if (this.shouldComplete) this.complete(this.completeValue!)
    }

    value(value: V) {
        this.receive = true
        this.last = value
    }
}

declare module '../stream' {
    interface Stream<SV = any, SE = any, SC = any, DV = SV, DE = SE, DC = SC> {
        lastOn(signal: Stream): MirrorStream<DV, DE, DC>
    }
}

Stream.prototype.lastOn = function <V, E, C>(this: AnySourceStream<V, E, C>, signal: Stream) {
    return new LastOn(signal, this) // tslint:disable-line:no-invalid-this
}
